module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dshLv"))).then(() => module.bundle.root('6TueN'));